var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M73.077,20.923H39.562c-1.104,0-2,0.896-2,2v33.515c0,1.104,0.896,2,2,2h33.515c1.104,0,2-0.896,2-2V22.923 C75.077,21.818,74.182,20.923,73.077,20.923z M71.077,54.438H41.562V24.923h29.515V54.438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.294,61.221H34.779V29.707c0-1.104-0.896-2-2-2s-2,0.896-2,2v33.514c0,1.104,0.896,2,2,2h33.515c1.104,0,2-0.896,2-2 S67.398,61.221,66.294,61.221z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.51,68.004H27.996V36.49c0-1.104-0.896-2-2-2s-2,0.896-2,2v33.514c0,1.104,0.896,2,2,2H59.51c1.104,0,2-0.896,2-2 S60.614,68.004,59.51,68.004z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStack);
export default __webpack_public_path__ + "static/media/stack.859caf37c05eea9a2a84eea4248eaa61.svg";
export { ForwardRef as ReactComponent };